import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import LoaderOverlay from "./LoaderOverlay";

const AuthRedirect = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoaderOverlay />;
  }

  // If logged in, go to dashboard, otherwise go to login
  return <Navigate to={isAuthenticated ? "/d" : "/login"} replace />;
};

export default AuthRedirect;
